import React from 'react';
import {connect} from 'react-redux';
import PropTypes from "prop-types";
import ConfigUtils from "../../qwc2/utils/ConfigUtils";
import axios from 'axios';
import {addDetailWindow, setDetailWindow} from "../actions/details";
import TypeUtils from "../utils/TypeUtils";
import Icon from "qwc2/components/Icon";

class FeatureBreadcrumb extends React.Component {

    static propTypes = {
        addDetailWindow: PropTypes.func,
        feature: PropTypes.object,
        setDetailWindow: PropTypes.func,
        type: PropTypes.string,
        url: PropTypes.string,
        windowId: PropTypes.string,
        windowType: PropTypes.string
    }

    static defaultProps = {
        feature: {},
        type: {},
        windowId: ''
    }

    constructor(props) {
        super(props);

        this.state = {
            physical: [],
            logical: [],
            isLoading: true
        };
    }

    componentDidMount() {
        const self = this;
        axios(this.props.url).then(response => {
            self.setState({
                physical: response.data.physical,
                logical: response.data.logical,
                isLoading: false
            });
        }).catch(error => {
            console.log("Error *** : " + error);
        });
    }

    render() {
        return (
            <div>
                {this.renderPhyical()}
                {this.renderLogical()}
            </div>
        );
    }

    renderLogical() {
        return this.renderCrumbs(this.state.logical);
    }

    renderPhyical() {
        return this.renderCrumbs(this.state.physical);
    }

    renderCrumbs(crumbs) {
        if (crumbs && crumbs.length) {
            return (
                <ul className="feature-breadcrumb">
                    {crumbs.map(p => {
                        let label = p.label;
                        if (!label) {
                            label = p.name;
                        }
                        const type = TypeUtils.getTypeLabel(p.type.toLowerCase());
                        if (p.type.toLowerCase() != type) {
                            label = type + ' ' + label;
                        }
                        return (
                            <li key={p.label}><Icon icon="chevron-right" /> <span className="link" onClick={() => this.clickCrumb(p)}>{label}</span></li>
                        );
                    })}
                </ul>
            );
        } else {
            return (<div></div>);
        }
    }

    clickCrumb(crumb) {
        this.goToObject(crumb.url, crumb.type);
    }

    goToObject(url, type) {
        //console.log('My type', this.props.windowType, type);
        const self = this;
        axios(url).then(response => {
            let object = null;
            let newWindow = false;
            if (response.data.features && response.data.features[0]) {
                object = response.data.features[0];
            } else if (response.data.properties) {
                object = response.data;
            }
            if (type === 'component') {
                object.detailWindowType = 'component';
                object.detailWindowUrl = url;
                if (self.props.windowType !== 'component') {
                    newWindow = true;
                }
            } else {
                if (self.props.windowType === 'component') {
                    newWindow = true;
                }
            }
            if (object !== null) {
                if (newWindow) {
                    this.props.addDetailWindow(object);
                } else {
                    this.props.setDetailWindow(self.props.windowId, object);
                }
            }
        }).catch(error => {
            console.log("Error *** : " + error);
        });
    }
}

const selector = () => ({});

export default connect(selector, {
    setDetailWindow: setDetailWindow,
    addDetailWindow: addDetailWindow
})(FeatureBreadcrumb);
